import { render } from "./RegistroDatos.vue?vue&type=template&id=e5103ce2&scoped=true"
import script from "./RegistroDatos.vue?vue&type=script&lang=js"
export * from "./RegistroDatos.vue?vue&type=script&lang=js"

import "./RegistroDatos.vue?vue&type=style&index=0&id=e5103ce2&scoped=true&lang=css"

import exportComponent from "D:\\WEB\\LICEO\\CURSOS\\portalalumnoscursos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5103ce2"]])

export default __exports__